import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Typography } from '@mui/material';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@components/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import { confirmAlert } from '@util/alert';
import { useDeleteLockdownBrowserAllowlistItem } from './ldb-allowlist-data-hooks';

const LockdownBrowserAllowlistItem = ({
  isAddingItem,
  allowlistItemId,
  allowlistItemProgram
}) => {
  const { deleteName, loading } = useDeleteLockdownBrowserAllowlistItem(allowlistItemId);
  const onHandleDelete = () => {
    confirmAlert(
      `Are you sure you want to remove ${allowlistItemProgram} from the Allowlist?`,
      deleteName
    );
  };
  return (
    <ListItem>
      <ListItemText primary={<Typography>{allowlistItemProgram}</Typography>} />
      <ListItemSecondaryAction>
        <IconButton
          edge="end"
          aria-label="delete"
          disabled={isAddingItem || loading}
          onClick={onHandleDelete}
          size="large"
        >
          {loading ? <CircularProgress size="1rem" thickness={5} /> : <DeleteIcon />}
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default LockdownBrowserAllowlistItem;
